export const PAYER = 'payer';
export const KIND = 'kind';
export const DESCRIPTION = 'description';

export const TIMINGS = {
  MORNING: 'morning',
  NOON: 'noon',
  EVENING: 'evening',
};

export const KINDS_PARTICIPANT = {
  LUNCH_BOX: 'lunchBox',
  STAFF_MEAL: 'staffMeal',
  SELF_CATERING: 'selfCatering',
  DINING: 'dining',
  RESTAURANT: 'restaurant',
  MARKET: 'market',
  OTHER: 'other',
};
export const KINDS_PARTICIPANT_VALUES = Object.values(KINDS_PARTICIPANT);

export const KINDS_BUSINESS = {
  LUNCH_BOX: 'lunchBox',
  STAFF_MEAL: 'staffMeal',
  SELF_CATERING_INGREDIENTS_PROVIDED: 'selfCateringIngredientsProvided',
  DINING: 'dining',
  RESTAURANT: 'restaurant',
  MARKET: 'market',
  HOME_COOKED: 'homeCooked',
  OTHER: 'other',
};
export const KINDS_BUSINESS_VALUES = Object.values(KINDS_BUSINESS);

export const KINDS = Object.assign(KINDS_PARTICIPANT, KINDS_BUSINESS);

export const PAYERS = {
  BUSINESS: 'business',
  PARTICIPANT: 'participant',
};

export const MEAL_GROUPINGS = {
  INDIVIDUAL: 'individual',
  ALL: 'all',
  MORNING_NOON: 'morningNoon',
  MORNING_EVENING: 'morningEvening',
  NOON_EVENING: 'noonEvening',
};
export const SNAKE_MEAL_GROUPINGS = {
  INDIVIDUAL: 'individual',
  ALL: 'all',
  MORNING_NOON: 'morning_noon',
  MORNING_EVENING: 'morning_evening',
  NOON_EVENING: 'noon_evening',
};
